"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const material_2 = require("@mui/material");
const CancelPresentation_1 = __importDefault(require("@mui/icons-material/CancelPresentation"));
const material_3 = require("@mui/material");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Tabs_1 = __importDefault(require("@mui/material/Tabs"));
const Tab_1 = __importDefault(require("@mui/material/Tab"));
const uiStyles_js_1 = require("../uiStyles.js");
const ResourceContainer_1 = __importDefault(require("../ResourceContainer"));
class GenericMenu extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialog: true,
            page: 0,
            tab: 0,
            tabIndex: {
                0: 'selected',
                1: 'idle',
            },
            hoverTab: undefined
        };
    }
    componentDidMount() {
    }
    render() {
        let { menuActive, menuTitle, menuColumns, onOpen, onClose, onChangeTab, allowOverflow, currentTab } = this.props;
        let overflowSetting = allowOverflow ? 'auto' : 'visible';
        let { tab, hoverTab } = this.state;
        if (currentTab !== undefined && currentTab !== tab) {
            this.setState({
                tab: currentTab,
                page: 0,
            });
        }
        const handleClickOpen = () => {
            onOpen();
        };
        const handleClose = () => {
            onClose();
        };
        const handleChange = (event, newValue) => {
            const { currentTab } = this.props;
            if (onChangeTab) {
                onChangeTab(newValue);
            }
            if (currentTab !== undefined) {
                this.setState({
                    tab: newValue,
                    page: 0,
                });
            }
        };
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Dialog_1.default, { fullWidth: true, maxWidth: 'lg', style: {
                    padding: '10px',
                }, onClose: handleClose, "aria-labelledby": "simple-dialog-title", 
                // onKeyDown={(event) => {
                //     console.log('keydown', event.key)
                // }}
                open: menuActive, TransitionProps: {
                    onExited: () => {
                    }
                } },
                react_1.default.createElement(material_3.IconButton, { style: {
                        alignSelf: 'flex-end',
                        marginTop: -5,
                        position: 'absolute',
                        zIndex: 999,
                    }, onClick: handleClose, size: "large" },
                    react_1.default.createElement(CancelPresentation_1.default, { style: { fontSize: '3rem' } })),
                react_1.default.createElement(material_1.Grid, { container: true, xs: 12 },
                    react_1.default.createElement(material_2.Paper, { style: Object.assign({
                            background: uiStyles_js_1.colorPalette.primary,
                            width: '100%',
                            maxHeight: '500px',
                            minHeight: '500px',
                            borderColor: uiStyles_js_1.colorPalette.primaryBorder,
                        }, uiStyles_js_1.bigScreenBorderProperties) },
                        react_1.default.createElement(material_1.Grid, { container: true, alignItems: "center", direction: "row", style: {
                                marginBottom: '1%'
                            } },
                            react_1.default.createElement(material_1.Grid, { container: true, item: true, xs: 12, alignItems: "center", justifyContent: "center", style: {
                                    paddingBottom: '2px',
                                    padding: '13px'
                                } },
                                react_1.default.createElement("b", { style: { fontSize: '22px' } },
                                    " ",
                                    menuTitle,
                                    " ")),
                            react_1.default.createElement(material_1.Grid, { item: true, xs: 12, style: { paddingBottom: '1.5%' } },
                                react_1.default.createElement(material_2.Paper, { square: true },
                                    react_1.default.createElement(Tabs_1.default, { value: tab, indicatorColor: "primary", textColor: "primary", onChange: handleChange, centered: true, style: {
                                            background: uiStyles_js_1.colorPalette.primary,
                                        } }, menuColumns.map((item, index) => {
                                        let backgroundColor;
                                        if (tab === index) {
                                            backgroundColor = '#FFD522';
                                        }
                                        else if (hoverTab == index) {
                                            backgroundColor = '#FFEE77';
                                        }
                                        else {
                                            backgroundColor = '#FFEFD2';
                                        }
                                        return react_1.default.createElement(Tab_1.default, { style: {
                                                background: backgroundColor,
                                                color: 'black',
                                                fontSize: '20px',
                                                textTransform: 'none',
                                                marginRight: '10px',
                                                borderTopLeftRadius: '8px',
                                                borderTopRightRadius: '8px',
                                                borderStyle: 'solid',
                                                borderColor: '#362D44',
                                                borderWidth: '3px',
                                                boxShadow: '0 0 0 1px #FFFFFF',
                                                padding: '3px',
                                            }, onMouseOver: () => {
                                                this.setState({ hoverTab: index });
                                            }, onMouseOut: () => {
                                                this.setState({ hoverTab: undefined });
                                            }, label: item.name });
                                    })))),
                            react_1.default.createElement(material_1.Grid, { container: true, xs: 12, style: {
                                    maxHeight: '300px',
                                    minHeight: '300px',
                                    pointerEvents: 'auto',
                                    overflow: overflowSetting,
                                } }, this.props.children),
                            this.props.includeResourceContainer && react_1.default.createElement(ResourceContainer_1.default, null))))));
    }
}
exports.default = (GenericMenu);
